/**
 * FeesSecurityStep Component
 * Step 4: Broker information and collateral / encumbrance
 */

import React from 'react';
import {
  Box,
  Card,
  CardContent,
} from '@mui/material';
import BrokerSection from '../sections/BrokerSection';
import CollateralSection from '../sections/CollateralSection';

function FeesSecurityStep() {
  return (
    <Box>
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <BrokerSection />
        </CardContent>
      </Card>

      <Card>
        <CardContent>
          <CollateralSection />
        </CardContent>
      </Card>
    </Box>
  );
}

export default FeesSecurityStep;
